module.exports = __webpack_public_path__ + "img/hover icon historial.8e194146.svg";